import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { Link, useHistory } from 'react-router-dom';
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false); 
  const [username, setUsername] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [confirmPassword, setConfirmPassword] = useState(''); 
  const history = useHistory();

  
  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => { 
    //console.log(username, password, confirmPassword); 
    let isValid = validateInput(formData);
    
    if (isValid) {
    let apicall = await performAPICall(); 
    if (apicall) {
      
    setUsername(''); 
    setPassword(''); 
    setConfirmPassword(''); 

    
enqueueSnackbar('Successfully registered', { variant: 'success' }); 
//history.push('/login');

  console.log("Successfully registered"); // use mui to show popup message 
  history.push('/login');
} else { 
  enqueueSnackbar(
'Username is already taken, try with other user and password!', 
{ variant: 'error' }
);
}
}
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const performAPICall = async () => { 
    try { 
      let res = await axios.post(config.endpoint+'/auth/register', {
    username,
    password, 
  }); 
  console.log(res.data.success);
  return true; 
} catch (error) {
    return false;
}
  };

  const validateInput = (data) => { 
    if (!username) {
  enqueueSnackbar('Username is a required field.', { variant: 'error' }); 
  return false;
    }
  if (username.length < 6) { 
    enqueueSnackbar('Username must be at least 6 characters long.', {
  variant: 'error', 
}); 
return false;
}
if (username.length > 32) { 
  enqueueSnackbar('Username must not exceed max length of 32.', {
variant: 'error', 
}); 
return false;
}
if (!password) {
enqueueSnackbar('Password is a required field.', { variant: 'error' }); 
return false;
}
if (password. length < 6) {
enqueueSnackbar('Password must be at least 6 characters long.', {
  variant: 'error',
}); 
return false;
}
if (password. length > 32) { 
  enqueueSnackbar('Password must not exceed max length of 32', {
variant: 'error', 
}); 
return false;
}
if (password !== confirmPassword) { 
  enqueueSnackbar('Password and confirm password do not match.', {
variant: 'error', 
}); 
return false;
}
return true; 
};

return (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    minHeight="100vh"
  >
    <Header hasHiddenAuthButtons />
    <Box className="content">
      <Stack spacing={2} className="form">
        <h2 className="title">Register</h2>
        <TextField
          id="username"
          label="Username"
          variant="outlined"
          title="Username"
          name="username"
          onChange={(e) => setUsername(e.target.value)}
          value={username}
          placeholder="Enter Username"
          fullWidth
        />
        <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            onChange={(e)=> setPassword(e.target.value)}
            value={password}
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            onChange={(e)=> setConfirmPassword(e.target.value)}
            value={confirmPassword}
            fullWidth
          />
          <Button className="button" variant="contained" onClick={register}>
            Register Now
           </Button>
           <p className="secondary-action">
            Already have an account?
            <Link className="link" to="/login"> Login here</Link>
            </p>

            {/* Already have an account? <Link to='/login'>Login here</Link>
            </p> */}
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
